import { Link } from "react-router-dom";
import React, { useMemo, useState, useEffect } from "react";
import { searchCustomer, searchSuperStaff } from "../utils/api";
import { CircularProgress } from "@mui/material";

const ApiSearch = ({ data, item, active, customer }) => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  // Fast Instant Local Filtering
  const filteredData = useMemo(() => {
    if (!search || !search.trim()) return data || [];
    const query = search.trim().toLowerCase();
    return (data || []).filter((it) => {
      const name = customer ? (it?.userName || "") : (it?.name || "");
      const phone = it?.phoneNumber || "";
      const groupName = it?.group?.name || "";
      return (
        name.toLowerCase().includes(query) ||
        phone.includes(query) ||
        groupName.toLowerCase().includes(query)
      );
    });
  }, [data, search, customer]);

  return (
    <div className="min-w-[18rem] md:w-72 bg-white rounded-2xl border border-gray-200 shadow-sm p-3.5 flex flex-col gap-3 h-fit">
      {/* Search Bar */}
      <div className="relative flex items-center">
        <span className="absolute left-3 text-gray-400 text-xs pointer-events-none">
          🔍
        </span>
        <input
          className="w-full bg-slate-50 border border-slate-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 rounded-xl py-2 pl-8 pr-8 text-xs font-semibold text-slate-800 placeholder-slate-400 transition outline-none"
          type="text"
          placeholder="Search customer..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        {search && (
          <button
            type="button"
            onClick={() => setSearch("")}
            className="absolute right-3 text-xs text-gray-400 hover:text-gray-600 font-bold p-0.5 cursor-pointer"
          >
            ✕
          </button>
        )}
      </div>

      {/* Directory List */}
      <div className="flex flex-col gap-1 max-h-[calc(100vh-14rem)] overflow-y-auto pr-1">
        {filteredData?.map((item2, index) => {
          const isActive = item2?._id === active;
          const displayName = customer ? item2?.userName : item2?.name;
          return (
            <Link
              to={!item ? "/admin/customer/:id" : "#"}
              onClick={(e) => {
                if (item) {
                  e.preventDefault();
                  item(item2);
                }
              }}
              className={`py-2 px-3 rounded-xl text-xs font-semibold transition-all duration-150 flex items-center justify-between no-underline select-none ${
                isActive
                  ? "bg-slate-900 text-white shadow-sm font-bold"
                  : "text-slate-700 hover:bg-slate-100/80 active:scale-98"
              }`}
              key={item2?._id || index}
            >
              <span className="truncate">{displayName}</span>
              {isActive && (
                <span className="text-[10px] bg-slate-700 text-slate-200 px-1.5 py-0.5 rounded-md ml-1 font-mono">
                  Active
                </span>
              )}
            </Link>
          );
        })}

        {(!filteredData || filteredData.length === 0) && (
          <div className="py-8 text-center text-xs text-gray-400 font-medium">
            No customers found
          </div>
        )}
      </div>
    </div>
  );
};

export default ApiSearch;
